module.exports = __webpack_public_path__ + "img/74_52.6d453f26.png";